export default {
    "messages": {
        "editor": {
            "tabs": {
                "posts": "Beiträge",
                "groups": "Organisationen"
            },
            "post": {
                "publish": "Veröffentlichen",
                "update": "Aktualisieren",
                "upload-picture": "Bild ändern",
                "title": "Überschrift",
                "content": "Inhalt",
                "location": "Ortschaft oder Adresse",
                "new-event": "Neue Veranstaltung",
                "edit-post": "Beitrag bearbeiten",
                "edit-event": "Veranstaltung bearbeiten",
                "post-as": "Verfasst von",
                "cant-add-more": "Sie können nicht mehr als",
                "images": "Bilder",
                "youtube-video": "Youtube Video",
                "youtube-video-placeholder": "https://www.youtube.com/...",
                "occurrences": "Datum auswählen...",
                "occurrences-placeholder": "Datum",
                "post-list": {
                    "create-new-post": "Neuen Beitrag verfassen",
                    "search-post": "Beitrag suchen...",
                    "last-modification": "Letzte Änderung am",
                    "no-result-for": "Keine Resultate gefunden für",
                    "refine-search": "Für zusätzliche Artikel, bitte Suche verfeinern"
                },
                "draft": {
                    "add-link": "Link hinzufügen",
                    "edit-link": "Link bearbeiten",
                    "insert-link": "Link einsetzen",
                    "link-address": "Adresse zum Link"
                },
                "picture-upload": {
                    "uploading-pictures": "Bilder hochladen ({processed}/{total})",
                    "saving": "Sichern"
                },
                "not-valid-youtube-link": "Ungültiger Youtube Link",
                "not-valid-link": "Ungültige URL",
                "delete-post": "Beitrag löschen",
                "delete-post-button": "Löschen",
                "alert-delete-post": "Sie sind dabei, diesen Beitrag unwiderruflich zu löschen: {postTitle}.",
                "file-size-exceeded": "Maximalgröße der Datei wurde überschritten (10MB)",
                "errors": {
                    "body-pic-video": "Beitrag, Bild oder Video muss näher beschrieben werden",
                    "bad-group": "Sie können keine Beiträge im Namen der Organisation veröffentlichen, da Sie kein Mitglied der Organisation sind",
                    "bad-json": "Mywort ist eine lokale Mittmachplattform in und für Luxemburg. Beiträge sind vor allem in den vier Sprachen Deutsch, Französisch, Englisch und Portugiesisch zu verfassen. Andere Sprachen oder Sonderzeichen sollten daher bitte vermieden werden."
                },
                "messages": {
                    "it-might-take-time": "Bis zur Aktualisierung kann es einige Minuten dauern.",
                    "save-success-title": "Ihr Beitrag wurde erfolgreich erstellt.",
                    "edit-success-title": "Ihr Beitrag wurde erfolgreich aktualisiert.",
                    "delete-success-title": "Ihr Beitrag wurde gelöscht."
                },
                "social-sharing": {
                    "message": "Teilen Sie Ihren Beitrag ebenfalls in den sozialen Netzwerken"
                },
                "linked-mission": "Mission",
                "language": "Language"
            },
            "group": {
                "my-groups": "Meine Organisationen",
                "joined-groups": "Mitgliedschaft",
                "manage": "Verwalten",
                "manage-group": "Organisation verwalten",
                "leave-group": "Organisation verlassen",
                "new-group": "Seite für Organisation erstellen",
                "edit-group": "Organisation bearbeiten",
                "wait-staff-validation": "Ihre Anfrage wird bearbeitet. Sie erhalten demnächst eine E-Mail.",
                "wait-user-validation": "Bitte warten bis der Manager die Anfrage bestätigt hat.",
                "declined-by-user": "Ihre Anfrage wurde vom Organisationsmanager abgelehnt.",
                "join-requests": "Anfragen",
                "maintainers": "Mitglieder",
                "no-users-request": "Keine Mitglieder bislang",
                "no-join-request": "Keine Beitrittsanfrage bislang",
                "show-declined-requests": "Abgelehnte Anfragen anzeigen",
                "delete-group": "Organisation löschen",
                "alert-leave-group": "Sie sind dabei, die '{groupName}' Organisation zu verlassen.",
                "alert-delete-group": "Sie sind dabei, die Organisation '{groupName}' unwiderruflich zu löschen. Durch diese Aktion wird die Organisation gelöscht und die Beiträge werden mit dem Namen des Autors angezeigt.",
                "please-enter-reason": "Bitte geben Sie einen Grund an...",
                "owner": "Manager",
                "picture-upload": {
                    "crop-picture": "Bild bearbeiten",
                    "preview-picture": "Vorschau",
                    "upload-picture": "Bild ändern",
                    "errors": {
                        "default-error": "Das Bild ist korrupt oder im falschen Format",
                        "bad-size": "Die Bildgröße ist unzulässig ({maxSize}mb Maximum, {minWidth}px Breite Minimum)"
                    }
                }
            }
        },
        "search":{
            "placeholder": "Text, Ort, Organisation",
            "for": "Suche nach '{input}' in mywort",
            "starttyping": "Text eingeben...",
            "noresults": "Keine Suchergebnisse gefunden",
            "title": "Suche...",
            "loading": "Suche läuft...",
            "results-all": "Suchergebnisse",
            "results-for": "Suchergebnisse für \"{item}\"",
            "results-around": " in {locality}",
            "results-by": " veröffentlicht von {group}",
            "discover-more": "Jetzt mehr entdecken",
            "filters": {
                "title": "Filter",
                "reset": "Filter zurücksetzen",
                "date": {
                    "placeholder": "Datum"
                },
                "locality": "Ortschaft",
                "municipality": "Gemeinde",
                "around": "Umgebung",
            },
            "suggestions": {
                "locality": "Ortschaft gefunden für",
                "localities": "Ortschaften gefunden für",
                "group": "Organisation gefunden für",
                "groups": "Organisationen gefunden für"
            }
        },
        "public": {
            "click-localize": "Klicken Sie hier, um die Ortsbestimmung festzulegen",
            "remove-localization": "Ortsbestimmung entfernen",
            "localization-error": "Sie haben abgelehnt, ihren  Standort zu teilen. Das können Sie jederzeit ändern, indem sie die Standortbestimmung in ihrem Browser erlauben.",
            "my-position": "Meine Position",
            "type-city": "Tippen, um eine Ortschaft auszuwählen",
            "more": "Mehr",
            "published-at": "veröffentlicht am",
            "search": "Suche",
            "advanced-search": "Weiterführende Suche",
            "please-enter-something": "Bitte etwas eingeben",
            "unlink-post": {
                "unlink": "Link aufheben",
                "sure-to-unlink": "Diese Aktion kann nicht widerrufen werden. Sind Sie sicher, dass Sie den  Link zu diesem Beitrag aufheben wollen?"
            },
            "legacy-group-request": {
                "want-create-group": "Ich möchte diese Organisation neu erstellen",
                "already-did-request": "Sie haben die Organisation neu erstellt.",
                "wait-for-validation": "Eine Anfrage wurde zur Validierung an den Administrator von mywort.lu gesendet.",
                "legacy-organisation": "Werde Manager einer Organisation, die von der alten Homepage übernommen wurde",
                "group-request-message": "Sie sind berechtigt, das Management dieser Organisation zu beantragen, die von der alten Homepage übernommen wurde. Seien Sie die/der Erste, klicken Sie hier und..."
            },
            "group-ownership-request": {
                "become-owner": "Werde Organisationsmanager",
                "group-ownership-message": "Veröffentlichen Sie Ihre Beiträge im Namen der Organisation",
                "want-to-own" : "Organisation übernehmen",
                "email-subject" : "Anfrage zur Übernahme einer Organisation. ",
                "email-body" : "Hallo, ich möchte der Manager von '{groupName}' Organisation werden. Mit freundlichen Grüßen, {ownerName}",
            },
            "group-request": {
                "modal": {
                    "group-name": "Name der Organisation",
                    "description": "Beschreibung"
                }
            },
            "join-group-request": {
                "modal" : {
                    "title" : "Beitrittsanfrage stellen",
                    "comments-to-owner" : "Sehr geehrter Organisationsmanager, \n" +
                        "Ich möchte Ihrer Organisation beitreten und Artikel im Namen Ihrer Organisation schreiben. \n" +
                        "Wären Sie damit einverstanden? \n" +
                        "Danke!"
                },
                "want-join-group": "Organisation beitreten",
                "already-did-request": "Sie haben bereits eine Anfrage gestellt, um dieser Organisation beizutreten",
                "wait-for-validation": "Eine Beitrittsanfrage wurde zur Validierung an den Organisationsmanager gesendet",
                "please-enter-comment": "Bitte Kommentar eingeben...",
                "become-maintainer": "Werde Mitglied",
                "join-group-message": "Eine Mitgliedschaft berechtigt Sie im Auftrag der Organisation, Beiträge zu erstellen. Klicken Sie auf die Schaltfläche und eine Beitrittsanfrage wird an den Organisationsmanager gesendet.",
            }
        },
        "user-module": {
            "signup-login": "Login",
            "manage-posts": "Beiträge<br>verwalten",
            "latest-posts": "Letzte Beiträge",
            "manage-groups": "Organisationen<br>verwalten",
            "logout": "Logout",
            "add-post": "Beitrag hinzufügen",
            "my-articles": "Beiträge",
            "my-groups": "Organisationen",
            "login-mywort": "Einloggen",
            "logout-mywort": "Ausloggen",
            "settings-mywort": "Profil bearbeiten",
            "profile": "Profil",
            "empty-post": "Kein Beitrag derzeit",
            "register-mywort": "Bei mywort anmelden",
            "carousel-title-1": "Kostenlos und für Sie gemacht",
            "carousel-sub-1": "Teilen Sie mit, was um Sie herum passiert oder was Sie bewegt.",
            "carousel-title-2": "Alles, was Ihnen gefällt",
            "carousel-sub-2": "Stellen Sie Artikel und Fotos ein.",
            "carousel-sub-2-1": "Diese könnten sogar in der Zeitung veröffentlicht werden.",
            "carousel-title-3": "Clubs, Vereinigungen, Verwaltungen",
            "carousel-sub-3": "Erstellen Sie eine eigene Homepage für Ihre Organisation.",
            "carousel-title-5": "Starten Sie jetzt",
            "already-member?": "Sind Sie bereits Mitglied?",
            "connect": "Einloggen",
            "hi": "Moien",
            "expect": "Herzlich Willkommen!",
            "take-a-look": "Sehen Sie sich unsere Webseite an und veröffentlichen Sie gleich ihre ersten Beiträge oder Veranstaltungen",
            "create-first": "Beitrag erstellen",    //Erstellen Sie ihren ersten Beitrag
            "create-text-footer": "Es dauert nur einige Minuten  - Versuchen Sie es!",
            "you-are-blocked": "Ihr mywort-Zugang wurde vom Administrator von mywort.lu gesperrt",
            "contact-admin" : "Kontaktieren Sie uns für weitere Informationen",
            "contact-email" : "contact@mywort.lu",
            "faq": "FAQ"
        },
        "geolocation": {
            "placeholder": "Stadt auswählen",
            "choose-city": "Überprüfen Sie Ihre Ortschaft",
            "fallback-city": "Konnte keinen passenden Ort finden: Luxemburg-Stadt wird ausgewählt."
        },
        "user-auth": {
            "loading": "Laden",
            "not-logged-in": "Sie sind nicht eingeloggt"
        },
        "picture-upload": {
            "drag-or-click-to-upload": "Bilder hierhin ziehen oder hier klicken, um Bilder hochzuladen",
            "remaining-pictures": "{pictures} Bilder möglich",
            "remove": "Entfernen",
            "retry": "Wiederholen",
            "upload-failed-error": "Ein unvorhergesehener Fehler ist aufgetreten. Bitte versuchen Sie es noch einmal oder entfernen Sie die falschen Bilder",
            "corrupted-pictures-error": "Einige der Fotos sind ungültig, bitte entfernen Sie diese Bilder",
            "bad-quality-pictures-warning": "Für manche Bilder die Bildgröße ist nicht optimal. Für die gedruckte Zeitung wird eine Mindestbreite von 2500 Pixel benötigt.",
            "not-accepted": "Diese Bilder wurden vom Server abgelehnt",
            "bad-color-profile": "Nicht unterstütztes Farbprofil.",
            "over-pixels": "Die Bildauflösung soll unter 35 Mpx liegen.",
            "over-bytes": "Die Bildgröße soll unter 20 MB liegen.",
            "try-again": "Bitte versuchen Sie es noch einmal.",
            "not-uploaded-yet": "Noch nicht hochgeladen",
            "will-be-main-picture": "Dieses Bild wird als Hauptbild in ihrem Beitrag angezeigt",
            "set-main-picture": "Als Hauptbild festlegen",
            "main-picture": "Hauptbild",
            "better-quality": "Achtung: Die Bildgröße ist nicht optimal. Für die gedruckte Zeitung wird eine Mindestbreite von 2500 Pixel benötigt."
        },
        "alert-box": {
            "default-message": "Etwas lief schief",
            "reload-message": "Klicken Sie hier, um die Seite neu zu laden"
        },
        "spinner": {
            "timeout-title": "Es scheint ein Problem zu geben...",
            "timeout-message": "Bitte überprüfen Sie ihre Verbindung oder laden Sie die Seite neu",
            "refresh-button-title": "Aktualisieren"
        },
        "react-validation": {
            "error-message-field-name": "Dieses Feld",
            "count-message": "{count} verbleibende Charaktere",
            "messages": {
                "required": "%s wird benötigt",
                "whitespace": "%s wird benötigt",
                "string": {
                    "min": "%s müssen minimum %s Charaktere sein",
                    "max": "%s kann nicht länger als %s Charaktere sein"
                },
                "number": {
                    "min": "%s kann nicht weniger sein als %s",
                    "max": "%s kann nicht größer sein als %s"
                }
            }
        },
        "react-select": {
            "no-result-found": "Keine Resultate gefunden"
        },
        "commons": {
            "submit": "Senden",
            "confirm": "Bestätigen",
            "close": "Schließen",
            "cancel": "Abbrechen",
            "go-back": "Zurück",
            "finish": "Ok",
            "view": "Ansicht",
            "edit": "Bearbeiten",
            "change": "Ändern",
            "accept": "Annehmen",
            "decline": "Ablehnen",
            "delete": "Löschen",
            "upload": "Hochladen",
            "locality": "Ortschaft",
            "users": "Nutzer",
            "group": "Organisation",
            "type": "Beitrag",
            "post": "Neuigkeit",
            "posts": "Neuigkeiten",
            "event": "Veranstaltung",
            "events": "Veranstaltungen",
            "new-contribution": "Neuer Beitrag",
            "comment-for-admin": "Warum wollen Sie diese Seite erstellen?",
            "picture": "Bild",
            "pictures": "Bilder",
            "create-group-request": "Seite für Organisation erstellen",
            "date": "Datum",
            "view-content-in-wort": "zur Ansicht",
            "view-group-in-wort": "zur Seite",
            "about": "Beschreibung",
            "filter": "Filter",
            "clear": "Löschen",
            "language": "Sprache"
        },
        "landing": {
            "tabs": {
                "posts": "Neuigkeiten",
                "events": "Veranstaltungen",
                "localitys": "Ortschaften",
                "groups": "Organisationen"
            },
            "info-box": {
                "locality-message": "In diesen Ortschaften wurden zuletzt Beiträge hochgeladen:",
                "group-message": "In diesen Organisationen wurden zuletzt Beiträge hochgeladen:"
            }
        }
    }
};



// WEBPACK FOOTER //
// ./js/mywort/commons/i18n/TranslationGerman.js